export const config={
    RsaPublicKey:'-----BEGIN PUBLIC KEY-----MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAoY8e9XE+wLDEA0ps24us2TZ3o/MTQ1WgcsADkNWYd8YucX6VW3ykol9gTMfV3WC3Ol6kH49Kq6naY7syxqBkHsjyQp8V25w5kiJrno3NlIfkwdd/xFJ2AxRQBz/BYHpIPtkBGvL/oV949Fed/k4in3iGgiWcshK4SWJ/Q8dm2C6H2PI8piF0kLLXPCM7h3wePuMUHb6A2hzuENhp+Kf5qmbrMz8q8PO3BvCsxKVX2273vFYX1+vFPS1r6rTMMayt6N3j+1tUSobAZ49Saew7rWjzYEy/s36hmCWqDAb++tLQtcgF1R+k0ZB+BdYMg5BLdXuF1Eyqcd5hiOH904uAZQIDAQAB-----END PUBLIC KEY-----'
};



// WEBPACK FOOTER //
// ./src/config/index.js